<template>
    <div>
        <datepicker 
            v-on:selected="getSelectedDate"
            v-model="inputDate"
            :language="languages[language]" 
            format="dd-MM-yyyy"
            :monday-first="true"
            :highlighted="highlighted"            
        ></datepicker>
        <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="formElement.dynamicTypeData.errorText" />
    </div>
</template>

<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import * as lang from "vuejs-datepicker/src/locale";
import moment from 'moment'

import {
    mapGetters
} from "vuex"

const state = {
    date1: moment(new Date(), 'YYYY-MM-DD').toDate()
};

export default {
    name: "kollecto-date",
    props: ['formElement', 'userAction'],
    watch: { 
        formElement: {
            immediate: true, 
            handler (newVal, oldVal) {
                if (this.userAction === 'newregistration' || !this.userAction) {
                    if(this.formElement.dynamicTypeData.value) {
                        const changedDate = this.formElement.dynamicTypeData.value.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                        this.inputDate = moment(changedDate, 'YYYY-MM-DD').toDate()
                    } else if (this.formElement.dynamicTypeData.defaultValue) {                
                        const changedDate = this.formElement.dynamicTypeData.defaultValue.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                        this.inputDate = moment(changedDate, 'YYYY-MM-DD').toDate()
                        //this.formElement.dynamicTypeData.value = this.inputDate                                                        
                        this.getSelectedDate(this.inputDate)
                    }                     
                    else {
                        //this.getSelectedDate(this.inputDate)                        
                    }
                } else {
                    const changedDate = this.formElement.dynamicTypeData.value.replace(/(..)\-(..)\-(....) (..):(..)/, '$3-$2-$1 $4:$5');
                    this.inputDate = moment(changedDate, 'YYYY-MM-DD').toDate()
                }
                         
                this.errorText = this.formElement.dynamicTypeData.errorText;
            }   
        }  
      },
    components: {
        Datepicker
    },
    data() {
        return {
            format: "dd-MM-yyyy",
            eventMsg: null,
            state: state,
            languages: lang,
            vModelExample: null,
            changedMonthLog: [],
            inputDate: null,                
            highlighted: {
                    dates: [ 
                        moment(new Date(), 'YYYY-MM-DD').toDate()
                    ]
                },
            errorText: ""
        };
    },
    computed: {
        ...mapGetters({
            selectedLanguage: "getSelectedLanguage"
        }),
        language() {
            // TODO: find out why selectedLanguage is different from default/global locale
            let lang = this.selectedLanguage.shorten;

            if (lang === "dk") {
                return "da";
            } else if (lang === "en") {
                return "en";
            } else if (lang === '' || lang === undefined || lang === null) {
                return "da";
            }
        }
    },
    methods: {
        getSelectedDate(date) {
            if (date === undefined || date === '' || date === null) {
                date = new Date()
            }
            this.formElement.dynamicTypeData.value = moment(date).format('DD-MM-YYYY hh:mm:ss')

              console.log("Date: " + this.formElement.dynamicTypeData.value)
          
        }
    },
    created() {

        //this.formElement.dynamicTypeData.value = this.inputDate.toString
    }
};
</script>

<style>
body {
  font-family: "Helvetica Neue Light", Helvetica, sans-serif;
  padding: 1em 2em 2em;
}
input,
select {
  padding: 0.75em 0.5em;
  font-size: 100%;
  border: 1px solid #ccc;
  width: 100%;
}

select {
  height: 2.5em;
}

.example {
  background: #f2f2f2;
  border: 1px solid #ddd;
  padding: 0em 1em 1em;
  margin-bottom: 2em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #ddd;
  border-radius: 3px;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

h5 {
  font-size: 100%;
  padding: 0;
}

.form-group {
  margin-bottom: 1em;
}

.form-group label {
  font-size: 80%;
  display: block;
}
</style>

